export default () => ({
  gallery: null,
  swiper: null,
  activeVideo: null, // Track the active video element
  settings: {
    slidesPerView: "auto",
    loop: true,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: ".carousel-pagination",
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="${className} carousel-bullet"></span>`,
    },
  },

  init() {
    this.$nextTick(() => {
      // Use `$nextTick` to ensure the DOM is updated before initializing Swiper
      this.gallery = this.$refs.carousel;

      // Only initialize if it doesn’t already exist, and store carousel as an instance for further interaction
      if (!this.swiper) {
        this.swiper = new window.Swiper(this.gallery, {
          ...this.settings,
          on: {
            slideChange: () => this.controlVideo(),
          },
        });
      }
    });
  },

  controlVideo() {
    this.$nextTick(() => {
      if (this.activeVideo) {
        this.activeVideo.pause(); // Pause the previous video
      }

      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      const video = activeSlide?.querySelector("video");

      if (video) {
        this.activeVideo = video;
        video.play(); // Play new active video
      }
    });
  },
});
